import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetPayComponetsForViewDto, PayComponetsDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewPayComponetsModal',
    templateUrl: './view-payComponets-modal.component.html'
})
export class ViewPayComponetsModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetPayComponetsForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetPayComponetsForViewDto();
        this.item.payComponets = new PayComponetsDto();
    }

    show(item: GetPayComponetsForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
